webpackJsonp([1],{

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FeatureProducts__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FeatureProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FeatureProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_faqs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_faqs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_faqs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeArticle__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HomeArticle__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FeatureProducts: __WEBPACK_IMPORTED_MODULE_2__components_FeatureProducts___default.a,
    HomeArticle: __WEBPACK_IMPORTED_MODULE_4__HomeArticle___default.a,
    Faqs: __WEBPACK_IMPORTED_MODULE_3__components_faqs___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Trang chủ'
    };
  },

  methods: {
    search: function search() {},
    getHomepage: function getHomepage() {
      Store.dispatch("homepage/getItems");
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("homepage", {
    items: "items",
    pagination: "pagination",
    loading: "loading",
    mode: "mode",
    snackbar: "snackbar",
    notice: "notice"
  })),
  mounted: function mounted() {
    this.getHomepage();
  },
  created: function created() {}
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getArticles();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("articles", {
    articles: "articles",
    pagination: "pagination"
  })),
  methods: {
    getArticles: function getArticles() {
      Store.dispatch("articles/getItems", {
        query: "",
        pagination: { page: 1, rowsPerPage: 5 }
      });
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-content"
  }, [_c('FeatureProducts'), _vm._v(" "), _vm._l((_vm.items), function(widget) {
    return _c('div', {
      key: widget.Id,
      staticClass: "widget",
      attrs: {
        "data-Name": widget.Name
      },
      domProps: {
        "innerHTML": _vm._s(widget.Body)
      }
    })
  }), _vm._v(" "), _c('home-article'), _vm._v(" "), _c('faqs')], 2)
},staticRenderFns: []}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-boxed"
  }, [_c('div', {
    staticClass: "pexeto-recent-posts rp-list"
  }, [_c('h3', {
    staticClass: "rp-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/articles"
    }
  }, [_vm._v(_vm._s(_vm.$t("article")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pb-10"
  }, [_c('v-expansion-panel', _vm._l((_vm.articles), function(item) {
    return _c('v-expansion-panel-content', {
      key: item.Id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('h3', [_vm._v(_vm._s(item.Name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [(item.Thumbnail) ? _c('div', {
      staticClass: "rp-date"
    }, [_c('img', {
      staticClass: "wp-post-image",
      attrs: {
        "src": item.Thumbnail,
        "alt": item.Name
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rp-info"
    }, [_c('h3', {
      staticClass: "pt-0"
    }, [_c('router-link', {
      attrs: {
        "to": item.SeName,
        "title": item.Name
      }
    }, [_vm._v(_vm._s(item.Name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "rp-cat"
    }, [_c('router-link', {
      attrs: {
        "to": item.SeName,
        "title": item.Short
      }
    }, [_vm._v(_vm._s(item.Short))])], 1)])])], 1)], 1)
  }), 1)], 1)])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// assets/js/1.76648c4ce5b6357a9c81.js